import React, { createContext, useContext, useState, ReactNode } from 'react';
import { ReturnQuery } from '../../../services/query';

interface LostCargoReturnDetailPageContextType {
    returnDetailData: any;
    setReturnDetailData: (data: any) => void;
    GetReturnDetailByReturnIdForLostCargo: (data: any) => void;
    loading: any;
}

interface LostCargoReturnDetailPageProviderProps {
    children: ReactNode;
}

const LostCargoReturnDetailPageContext = createContext<LostCargoReturnDetailPageContextType | undefined>(undefined);

export const LostCargoReturnDetailPageProvider: React.FC<LostCargoReturnDetailPageProviderProps> = ({ children }) => {
    const [returnDetailData, setReturnDetailData] = useState<any>(null);
    const [loading, setLoading] = useState<any>(null);

    const GetReturnDetailByReturnIdForLostCargo = (request: any) => {
        setLoading(true);
        let req = { customerId: request.customerId, returnId: request.returnId };
        ReturnQuery.GetReturnDetailByReturnIdForLostCargo(req)
            .then((res: any) => {
                if (res.data.productDetailModels) {
                    const updatedProducts = res.data.productDetailModels.map((product: any) => {
                        // Eğer hem restockQuantity hem de nonRestockQuantity 0 ise
                        if (product.restockQuantity === 0 && product.nonRestockQuantity === 0) {
                            return {
                                ...product,
                                restockQuantity: product.piece,
                                nonRestockQuantity: 0,
                                rejectedQuantity: product.rejectedQuantity || 0,
                            };
                        }

                        // Eğer restockQuantity ve nonRestockQuantity toplamı piece'den küçükse
                        const totalQuantity = (product.restockQuantity || 0) + (product.nonRestockQuantity || 0);
                        if (totalQuantity < product.piece) {
                            const remainingQuantity = product.piece - totalQuantity;
                            return {
                                ...product,
                                restockQuantity: (product.restockQuantity || 0) + remainingQuantity,
                                nonRestockQuantity: product.nonRestockQuantity || 0,
                                rejectedQuantity: product.rejectedQuantity || 0,
                            };
                        }

                        // Normal durumda mevcut değerleri koru
                        return {
                            ...product,
                            restockQuantity: product.restockQuantity || 0,
                            nonRestockQuantity: product.nonRestockQuantity || 0,
                            rejectedQuantity: product.rejectedQuantity || 0,
                        };
                    });
                    res.data.productDetailModels = updatedProducts;
                    setReturnDetailData(res.data);
                }
            })
            .finally(() => {
                setLoading(false);
            });
    };

    const value = {
        returnDetailData,
        setReturnDetailData,
        GetReturnDetailByReturnIdForLostCargo,
        loading,
    };

    return (
        <LostCargoReturnDetailPageContext.Provider value={value}>{children}</LostCargoReturnDetailPageContext.Provider>
    );
};

export const useLostCargoReturnDetailPage = () => {
    const context = useContext(LostCargoReturnDetailPageContext);
    if (context === undefined) {
        throw new Error('useLostCargoReturnDetailPage must be used within a LostCargoReturnDetailPageProvider');
    }
    return context;
};
